module.exports = __webpack_public_path__ + "img/Eduzz-12-en.31d6938e.png";